import React, { useEffect, useState } from "react";
import axios from "axios";
import {
  Theme,
  Card,
  Flex,
  Text,
  TextArea,
  Button,
  Separator,
} from "@radix-ui/themes";
import { Link } from "react-router-dom";
import { toast } from "react-hot-toast";
import { API_URL } from "../constants/constants";

function Dashboard() {
  const [form, setForm] = useState({
    name: "",
    username: "",
    description: "",
    socialLinks: {
      linkedin: "",
      github: "",
      twitter: "",
      website: "",
    },
    theme: "",
    calcomUsername: "",
  });

  useEffect(() => {
    const fetchData = async () => {
      const token = localStorage.getItem("token");
      const res = await axios.get(`${API_URL}/api/user/me`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      setForm(res.data);
    };
    fetchData();
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;

    const socialFields = ["linkedin", "github", "twitter", "website"];
    if (socialFields.includes(name)) {
      setForm((prev) => ({
        ...prev,
        socialLinks: {
          ...prev.socialLinks,
          [name]: value,
        },
      }));
    } else {
      setForm((prev) => ({
        ...prev,
        [name]: value,
      }));
    }
  };

  const handleSubmit = async () => {
    const token = localStorage.getItem("token");
    await axios.put(`${API_URL}/api/user/me`, form, {
      headers: { Authorization: `Bearer ${token}` },
    });
    toast.success("Profile updated.", {
      style: {
        border: "1px solid rgb(0, 0, 0)",
        padding: "12px",
        color: "#000",
      },
      iconTheme: {
        primary: "#000",
        secondary: "#FFFAEE",
      },
    });
  };

  const inputStyle = {
    width: "100%",
    padding: "0.5rem",
    backgroundColor: "#111",
    color: "#fff",
    border: "1px solid #333",
    borderRadius: "6px",
    fontSize: "14px",
  };

  return (
    <Theme
      appearance="dark"
      accentColor="crimson"
      radius="medium"
      style={{ height: "100vh", paddingBottom: "2rem" }}
    >
      <Flex
        align="center"
        justify="center"
        style={{ minHeight: "100vh", padding: "2rem", backgroundColor: "#111" }}
      >
        <Card size="4" style={{ width: "100%", maxWidth: "600px" }}>
          <Flex direction="column" gap="4">
            <Text size="5" weight="bold" align="center">
              Update Profile
            </Text>
            <Text size="2" color="gray">
              Welcome, {form?.name}
            </Text>

            <input
              style={inputStyle}
              name="username"
              placeholder="Username (unique)"
              value={form?.username}
              onChange={handleChange}
            />

            <TextArea
              name="description"
              placeholder="Description"
              value={form?.description}
              onChange={handleChange}
              style={{ height: "80px" }}
            />

            <Separator my="2" size="4" />

            <input
              style={inputStyle}
              name="linkedin"
              placeholder="LinkedIn URL"
              value={form?.socialLinks?.linkedin}
              onChange={handleChange}
            />
            <input
              style={inputStyle}
              name="github"
              placeholder="GitHub URL"
              value={form?.socialLinks?.github}
              onChange={handleChange}
            />
            <input
              style={inputStyle}
              name="twitter"
              placeholder="Twitter URL"
              value={form?.socialLinks?.twitter}
              onChange={handleChange}
            />
            <input
              style={inputStyle}
              name="website"
              placeholder="Website"
              value={form?.socialLinks?.website}
              onChange={handleChange}
            />

            <input
              style={inputStyle}
              name="calcomUsername"
              placeholder="Cal.com Username"
              value={form?.calcomUsername}
              onChange={handleChange}
            />

            <Separator my="2" size="4" />

            <Button>
              <Link
                to={"/dashboard/theme"}
                style={{ color: "#fff", textDecoration: "none" }}
              >
                Choose Theme
              </Link>
            </Button>
            <Button onClick={handleSubmit}>Save Profile</Button>
          </Flex>
        </Card>
      </Flex>
      {form?.username && (
        <a
          href={`/u/${form?.username}`}
          target="_blank"
          rel="noopener noreferrer"
          style={{
            position: "fixed",
            bottom: "1rem",
            right: "1rem",
            fontSize: "14px",
            color: "#fff",
            border: "2px dashed #333",
            padding: "0.5rem 1rem",
            borderRadius: "8px",
            textDecoration: "none",
          }}
        >
          View Public Profile
        </a>
      )}
    </Theme>
  );
}

export default Dashboard;
